import Emitter from "./Emitter";

export default class TicketResolved extends Emitter {
    constructor(gb) {
        super(gb);
    }

    _default() {
        this.emitParent({ wpgaction: "ticketResolved.parent" });
        this.emitTop({ wpgaction: "ticketResolved" });
        this.emitiOS({ wpgaction: "ticketResolved" });
    }
}
